import { Auth } from 'aws-amplify';
import API from '@aws-amplify/api';
import axios from "axios";

import { getLocalStorage, setLocalStorage, deleteLocalStorage } from './LocalStorageUtils';
import { parseInteger } from './ParseInteger';
import { getCurrencyCodeFromSymbol } from './Currency';
// import { backendConfig } from "../backend-config-dev";
// import { backendConfig } from "../backend-config-test";
import { backendConfig } from "../client-config";

/* This is only to implement order methods */

export const orderTypes = {
  DINE_IN: 'Dine In',
  DELIVERY: 'Delivery',
  SELF_PICK_UP: 'Self Pick Up',
};

export const orderStatuses = {
  ORDERING: 'ORDERING',
  ORDERED: 'ORDERED',
  ACCEPTED: 'ACCEPTED',
  PREPARING: 'PREPARING',
  READY: 'READY',
  ON_THE_WAY: 'ON THE WAY',
  DELIVERED: 'DELIVERED',
  COMPLETED: 'COMPLETED',
};

export const createNewOrder = async (orderDetails) => {
  let orderId = '';
  if (Object.keys(orderDetails).length) {
    // its a new order
    const apiName = 'CreateNewOrder';
    const path = '';
    const user = await Auth.currentSession();
    let token = user.idToken.jwtToken;
    if (token) {
      const myInit = {
        body: orderDetails,
        headers: {
          "Authorization": token,
        },
      };

      try {
        await API.post(apiName, path, myInit).then((response) => orderId = response.orderId)
        .catch(error => {
          console.log(error);
        });
      } catch (error) {
        console.log(error);
      }
    }
  }
  return orderId;
}

export const updateOrderPayment = async (orderDetails) => {
  let putStatus = false;
  const orderId = getLocalStorage('orderId');
  if (Object.keys(orderDetails).length) {
    const apiName = 'UpdateOrderByOrderId';
    const path = '/' + orderId;
    const user = await Auth.currentSession();
    let token = user.idToken.jwtToken;
    if (token) {
      const myInit = {
        body: orderDetails,
        headers: {
          "Authorization": token,
        },
      };

      try {
        await API.put(apiName, path, myInit).then(response => {
          setLocalStorage('paymentStatus', orderDetails.payment);
          return putStatus = true;
        })
        .catch(error => {
          setLocalStorage('paymentStatus', 'FAILED');
          console.log(error);
          return false;
        });
      } catch (error) {
        console.log(error);
      }
    }
  }
  return putStatus;
}

export const updateOrderByNotify = async (orderDetails) => {
  //let putStatus = false;
  const orderId = getLocalStorage('orderId');
  /*console.log(orderId);*/
  if (Object.keys(orderDetails).length) {
    let data = "orderId=" + orderId 
      + "&orderAmount=" + orderDetails.orderAmount 
      + "&referenceId=" + orderDetails.referenceId 
      + "&txStatus=" + orderDetails.txStatus 
      + "&paymentMode=" + orderDetails.paymentMode 
      + "&txMsg=" + orderDetails.txMsg 
      + "&txTime=" + orderDetails.txTime;
      //+ "&signature=" + orderDetails.signature;
    /*const apiName = 'UpdateOrderByNotify';*/
    const path = backendConfig.notifyUrl;
    const body = encodeURI(data) + "&signature=" + encodeURIComponent(orderDetails.signature);

    return new Promise(async (resolve, reject) => {
      await axios.post(
        path, 
        body, 
        {
          headers: { 
            'Content-Type' : 'application/json' 
          }
        }
      ).then(response => {
        resolve(response.data);
      })
      .catch(error => {
        console.log(error);
        resolve(false);
      });
    });
  }
  /*{
    console.log(response);
    putStatus = true;
  })*/
}

export const getAllUserOrders = async () => {
  let allOrders = {};
  const apiName = 'GetAllOrdersByUser';
  const path = '';
  let token = '';
  let user = null;
  try {
    user = await Auth.currentSession();
    token = user.idToken.jwtToken;

    if (token && token !== '') {
      const myInit = {
        response: true,
        headers: {
          "Authorization": token,
        },
      };

      try {
        await API.get(apiName, path, myInit)
        .then(response => allOrders = response.data)
        .catch(error => {
          console.log(error);
        });
      } catch (error) {
        console.log(error);
      }

    }
  } catch (error) {
    console.log(error);
  }
  return allOrders;
}

export const getOrderByOrderId = async (orderId='') => {
  let order = {};
  if (orderId === '') {
    orderId = getLocalStorage('orderId');
  }
  if (orderId !== false) {
    const apiName = 'GetOrderByOrderId';
    const path = '/' + orderId;
    const user = await Auth.currentSession();
    let token = user.idToken.jwtToken;
    if (token) {
      const myInit = {
        headers: {
          "Authorization": token,
        },
      };

      try {
        await API.get(apiName, path, myInit)
        .then((response) => order = response)
        .catch(error => {
          order = false;
          console.log(error);
        });
      } catch (error) {
        console.log(error);
      }
    }
  }
  return order;
}

export const getPaymentTokenForOrder = async (orderDetails) => {
  let payToken = '';
  const orderId = getLocalStorage('orderId');
  if (orderId !== false && Object.keys(orderDetails).length) {
    let data = "appId=" + orderDetails.appId 
      + "&orderId=" + orderDetails.orderId 
      + "&orderAmount=" + orderDetails.orderAmount 
      + "&returnUrl=" + orderDetails.returnUrl 
      + "&paymentModes=" + orderDetails.paymentModes;
    const apiName = 'GetPaymentToken';
    const path    = data;
    const user    = await Auth.currentSession();
    let token     = user.idToken.jwtToken;
    if (token) {
      const myInit = {
        headers: {
          "Authorization": token,
        },
      };

      try {
        await API.get(apiName, path, myInit)
        .then((response) => payToken = response.paymentToken)
        .catch(error => {
          payToken = false;
          console.log(error);
        });
      } catch (error) {
        console.log(error);
      }
    }
  }
  return payToken;
}

export const paymentData = (orderDetails) => {
  // const testappId = "17815051b3a7fe45046249de551871"; // for test env
  const testappId = "92345fc8e2b0c4b7552c195ed54329"; // for prod env
  let orderId     = getLocalStorage('orderId');

  console.log(orderId);

  if (orderId === false || !Object.keys(orderDetails).length) {
    return false;
  }

  let orderNote = 'Placing order for ' + orderDetails.orderUsername + ' on ' + (new Date().toUTCString());

  let customerEmail = '';

  if (!getLocalStorage('offlineMode') && 'email' in orderDetails.selected_delivery_address) {
    customerEmail = orderDetails.selected_delivery_address.email;
  }

  let postData = {
    appId: testappId,
    customerEmail: customerEmail,
    customerName: orderDetails.selected_delivery_address.fullName,
    customerPhone: orderDetails.orderUsername,
    /*notifyUrl: NgRokHost + "/notifyBackend",*/
    notifyUrl: backendConfig.notifyUrl,
    orderAmount: orderDetails.totalPayableAmount,
    /*orderCurrency: orderDetails.currency,*/
    orderCurrency: getCurrencyCodeFromSymbol(orderDetails.currency),
    orderId: orderId,
    orderNote: orderNote,
    /*returnUrl: NgRokHost + "/paymentStatus",*/
    returnUrl: "",
    paymentModes: "",
  };

  return postData;
}

export const deleteOrderStorage = async () => {
  // deletes all order related local storage data
  let keys = [
    'finalOrder',
    'gstAmount',
    'shopName',
    'shopStatus',
    'shopType',
    'phoneNumber',
    'shopGST',
    'shopId',
    'totalPayableAmount',
    'paymentStatus',
    'scart_state',
    'optDelivery',
    'shopPhoneNumber',
  ];

  const isOffline = getLocalStorage('offlineMode');

  if (isOffline === 'OK') {
    /* keys = [
      'finalOrder',
      'totalPayableAmount',
      'paymentStatus',
      // 'orderId',
    ]; */
    keys.push(
      'finalOrder',
      'totalPayableAmount',
      'paymentStatus',
    );
  }

  for (var i = 0; i < keys.length; i++) {
    deleteLocalStorage(keys[i]);
  }
}

export const handleItemName = (itemName) => {
  if (itemName.includes('___')) {
    let res = itemName.split('___');
    return res[0];
  } else {
    return itemName;
  }
}

export const calculateTaxes = (cartState) => {
  // Calculate GST
  let taxAmt = 0;
  const gstTax = parseInteger(getLocalStorage('shopGST'));
  taxAmt = (gstTax/100) * cartState.total;
  taxAmt = taxAmt.toFixed(2);

  setLocalStorage('gstAmount', Number(taxAmt));

  return calculatePayableAmounts(taxAmt, cartState);
}

const calculatePayableAmounts = (taxAmt, cartState) => {
  let total = 0;
  let checkedDelivery = getLocalStorage('optDelivery');
  let deliveryCharge  = cartState ? cartState.deliveryCharge : 10;
  if (cartState.total) {
    total = Number(parseInteger(cartState.total)) + Number(taxAmt);
    if (checkedDelivery === true) {
      total = Number(parseInteger(deliveryCharge)) + Number(total);
      setLocalStorage('totalPayableAmount', total);
    } else {
      setLocalStorage('totalPayableAmount', total);
    }
  }
  return total;
}

export const buildFinalOrder = (orderType, userDetails, address='') => {
  let readyOrder = {};
  let delivery     = getLocalStorage('optDelivery');
  const orderState = getLocalStorage('scart_state');
  if (orderState !== false && Object.keys(orderState).length && Object.keys(userDetails).length) {
    readyOrder = {
      orderType: orderType,
      orderUsername: userDetails.username,
      orderItems: orderState.addedItems,
      shopId: orderState.shopDetails.shopId,
      shopName: orderState.shopDetails.shopName,
      selected_delivery_address: orderType === 'DELIVERY' ? address : '',
      deliveryCharge: delivery === true ? orderState.deliveryCharge : 0,
      gstAmount: Number(getLocalStorage('gstAmount')),
      totalPayableAmount: Number(getLocalStorage('totalPayableAmount')),
      payment: 'NOT_PAID',
      currency: orderState.addedItems[0].currency,
      /*orderTime: new Date().toUTCString(),*/
      orderTime: Date.now(),
      orderStatus: 'ORDERING',
    };

    if (orderType === 'SELF_PICK_UP') {
      let spAdd = {
        fullName: address.fullName,
        email: address.email,
        /*city: address.city,
        state: address.state,
        country: address.country,*/
      };
      readyOrder['selected_delivery_address'] = spAdd;
    }

    if (orderType === 'DINE_IN') {
      readyOrder['tableNumber']   = getLocalStorage('tableNumber');
      readyOrder['portalCharges'] = getLocalStorage('portalCharges');
    }

    const isOffline = getLocalStorage('offlineMode');

    if (isOffline === 'OK') {
      const orderItemsLength = Object.keys(readyOrder.orderItems).length;
      for (let i = 0; i < orderItemsLength; i++) {
        readyOrder.orderItems[i].item = handleItemName(readyOrder.orderItems[i].item);
      }
    }

    setLocalStorage('finalOrder', readyOrder);
  }

  return readyOrder;
}
